import React from "react";

export default function StarBorder({
  as: Component = "div",
  className = "",
  color = "#E67000",
  speed = "10s",
  radius = "20px",
  active = false,
  children,
  ...props
}) {
  return (
    <Component
      className={`relative p-[2px] overflow-hidden ${className}`}
      style={{ borderRadius: radius, ...props.style }}
      {...props}
    >
      {active && (
        <div
          className="absolute inset-[-1000%] animate-[spin_linear_infinite] pointer-events-none"
          style={{
            animationDuration: speed,
            background: `conic-gradient(from 0deg, transparent 0 340deg, ${color} 360deg)`,
          }}
        />
      )}

      <div
        className="relative z-20 bg-black w-full h-full"
        style={{ borderRadius: `calc(${radius} - 2px)` }}
      >
        {children}
      </div>

      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </Component>
  );
}